import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import { Form } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { injectModels } from "../../../redux/injectModels";
import { routes } from "../../../constants/routes";

import Editor from "react-simple-wysiwyg";

import { EventContractService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

const EventContactModel = {
  id: "",
  contractName: "",
  eventName: "",
  contractDtl: "",
  contractFor: "",
  isActive: false,
};

const EditEventContact = (props) => {
  const id = EventContractService.getContractId();
  const navigate = useNavigate();
  const [contractData, setContractData] = useState({ ...EventContactModel });
  const { eventId } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const getEventContractByid = async () => {
    try {
      const res =
        (id && (await EventContractService.getEventContractById(id))) || [];
      const pitchMappedData = { ...EventContactModel, ...res?.data };
      reset(pitchMappedData);
      setContractData(pitchMappedData);
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  useEffect(() => {
    if (!eventId) {
      // navigate(routes.ACCOUNT_EVENTS);
    }
    getEventContractByid();
  }, []);

  const onSubmit = async (data) => {
    try {
      let response = null;
      data.contractName = contractData?.contractData;
      data.eventName = contractData?.eventName;
      data.contractDtl = contractData?.contractDtl;
      data.contractFor = contractData?.contractFor;
      data.isActive = contractData?.isActive;

      props.application.setLoading(true);
      if (id) {
        response = await EventContractService.updateEventContract(data);
      }
      if (response?.isSuccess) {
        EventContractService.removeContractId();
        props.application.setLoading(false);
        toast.success(response?.message);
        navigate(routes.Event_CONTRACT.replace(":eventId", eventId));
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      toast.error(error?.message);
    }
  };

  const handleIsStatus = (event) => {
    setContractData({
      ...contractData,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleDescription = (e) => {
    const val = e.target.value;
    setContractData({
      ...contractData,
      contractDtl: val,
    });
  };

  return (
    <React.Fragment>
      {/* <section className="subscription-banner p-0">
        <div className="container">
          <h3>Pitches</h3>
        </div>
      </section> */}
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="contractName" className="mb-3">
          <Form.Label>
            Contract Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("contractName", {
              required: "Please enter Contract Name",
            })}
            defaultValue={contractData?.contractName}
            // disabled={id}
            disabled={!!contractData.id}
          />
          {errors.contractName && (
            <span className="text-danger">{errors.contractName?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="eventName" className="mb-3">
          <Form.Label>
            Event Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("eventName", {
              required: "Please enter Event Name",
            })}
            defaultValue={contractData?.eventName}
            disabled={!!contractData.id}
          />
          {errors.eventName && (
            <span className="text-danger">{errors.eventName?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="contractDtl" className="mb-3">
          <Form.Label>Contract Details</Form.Label>
          <Editor
            value={contractData.contractDtl}
            onChange={handleDescription}
          />
          {errors.contractDtl && (
            <span className="text-danger">{errors.contractDtl?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="contractFor" className="mb-3">
          <Form.Label>
            Contract For <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("contractFor", {
              required: "Please enter Contract Name",
            })}
            defaultValue={contractData.contractFor}
            disabled={!!contractData.id}
          />
          {errors.contractFor && (
            <span className="text-danger">{errors.contractFor?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="refundable" className="mb-3">
          <Form.Label>Status</Form.Label>
          <Form.Check
            type="checkbox"
            defaultValue={contractData.isActive}
            checked={contractData.isActive} // Controlled by state
            onChange={handleIsStatus} // Handle change event
          />
          {/* {errors.refundable && (
            <span className="text-danger">{errors.refundable?.message}</span>
          )} */}
        </Form.Group>

        <button
          className="btn btn-primary mt-3"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </button>
      </Form>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EditEventContact);
